module.exports = __webpack_public_path__ + "img/phone-solid-light.af8f24f7.svg";